<!-- <div class="loader-container" *ngIf="showLoader">
  <div class=" loader"></div>
</div> -->
<!-- <jqxWindow #form [theme]="theme" [width]="mapWidth" [height]="mapHeight" [zIndex]="999" [position]="getFormPos(form, 0)"
  [autoOpen]="true" [showCloseButton]="true" [showCollapseButton]="true" [resizable]="true" (onClose)="onClose()"
  (onCollapse)="onCollapse($event)" (onExpand)="onExpand($event)"> -->
<!-- <div class="formHeader" style="overflow-x: hidden;">
    {{translate('Historico_alarmas_IoT')}}
  </div> -->
<div class="form" style="position: absolute; z-index: 1000; display: flex; height: 100%; width: 100%;">
  <div style="overflow-x: hidden; width: 100%;">
    <div style="float: left; margin-top: 2px; height:95%; width: '100%';">
      <div>
        <app-header #header [buscador]="true" [exportar]="true" [periodo]="true" [filtro]="true" [resetFiltro]="true"
          [seeCheckAlarms]="true" (eventExportar)="onExportar()" (eventFilter)="onAceptar()"
          (eventResetFilter)="onResetFilter()" (eventBuscador)="onBuscar()" (eventCheckAlarms)="onCheckAlarms($event)">
        </app-header>
      </div>
      <div style="height: calc(100% - 50px);">
        <jqxGrid #grid [theme]="theme" [width]="'100%'" [height]="'100%'" [source]="dataAdapter" [columnsresize]="true"
          [sortable]="true" [showrowlines]="false" [showcolumnlines]="true" [columns]="columns" [altrows]="true"
          [filterable]="true" [showstatusbar]="true" [showaggregates]="true" [columnsautoresize]="true"
          [localization]="langGrid" [groupable]="true" [showemptyrow]="false" [statusbarheight]="20"
          (onGroupschanged)="resizeColumns()" [columnsheight]="20" [rowsheight]="20">
        </jqxGrid>
      </div>
    </div>
  </div>
</div>
<!-- </jqxWindow> -->